import { Language } from '../../../language'
import { useConfig } from '../../../providers/envConfig'
import { ConsentResponseWithAccountDetails } from '../../../types/Account'
import useFetch from '../../helpers/useFetch'

/**
 * `usePutConsentByID` is a custom hook to put data at the /accounts/{id}/consent endpoint.
 * @param id {string} - The Verifiable Parental Consent Service (VPCS) ID of the account
 * @param givenName {string} - The given name of the player requesting consent
 * @param parentEmail {string} - The email address of the approver (parent/guardian)
 * @param jwt {string} - The JSON Web Token (JWT) for authentication
 * @param [parentLanguage] {string} - The language preferred for email communication with approver (parent/guardian)
 */
const usePutConsentByID = (
  id: string,
  givenName: string,
  parentEmail: string,
  jwt: string,
  parentLanguage?: Language,
) => {
  const envConfig = useConfig()

  const url = `${envConfig.vpcUrl}/accounts/${id}/consent`
  const fields: RequestInit = {
    method: 'PUT',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${jwt}`,
      'X-Bnet-Key': envConfig.bnetKey,
    },
    body: JSON.stringify({
      givenName,
      parentEmail,
      parentLanguage,
    }),
  }

  const { data, loading, error, callFetch } = useFetch<ConsentResponseWithAccountDetails>(
    url,
    fields,
  )

  return { data, loading, error, callFetch }
}

export default usePutConsentByID
